/** 이니시스 가상계좌 환불 API `refundBankCode` 셀렉트용 (발급은행 코드) */
export type InicisRefundBankOption = { value: string; text: string }

const rows: [string, string][] = [
  ['02', '한국산업은행'],
  ['03', '기업은행'],
  ['04', '국민은행'],
  ['05', '하나은행 (구 외환)'],
  ['06', '국민은행 (구 주택)'],
  ['07', '수협중앙회'],
  ['11', '농협중앙회'],
  ['12', '단위농협'],
  ['16', '축협중앙회'],
  ['20', '우리은행'],
  ['21', '구)조흥은행'],
  ['22', '상업은행'],
  ['23', 'SC제일은행'],
  ['24', '한일은행'],
  ['25', '서울은행'],
  ['26', '구)신한은행'],
  ['27', '한국씨티은행 (구 한미)'],
  ['31', '대구은행'],
  ['32', '부산은행'],
  ['34', '광주은행'],
  ['35', '제주은행'],
  ['37', '전북은행'],
  ['38', '강원은행'],
  ['39', '경남은행'],
  ['45', '새마을금고'],
  ['48', '신용협동조합중앙회'],
  ['50', '상호저축은행'],
  ['53', '한국씨티은행'],
  ['54', '홍콩상하이은행'],
  ['55', '도이치은행'],
  ['56', 'ABN암로'],
  ['57', 'JP모건'],
  ['59', '미쓰비시도쿄은행'],
  ['60', 'BOA(Bank of America)'],
  ['64', '산림조합'],
  ['70', '신안상호저축은행'],
  ['71', '우체국'],
  ['81', '하나은행'],
  ['83', '평화은행'],
  ['87', '신세계'],
  ['88', '신한(통합)은행'],
  ['89', '케이뱅크'],
  ['90', '카카오뱅크'],
  ['91', '네이버포인트'],
  ['92', '토스뱅크'],
  ['93', '토스머니'],
  ['94', 'SSG머니'],
  ['96', '엘포인트'],
  ['97', '카카오머니'],
  ['98', '페이코포인트'],
  ['D1', '유안타증권'],
  ['D2', '현대증권'],
  ['D3', '미래에셋증권'],
  ['D4', '한국투자증권'],
  ['D5', '우리투자증권'],
  ['D6', '하이투자증권'],
  ['D7', 'HMC투자증권'],
  ['D8', 'SK증권'],
  ['D9', '대신증권'],
  ['DA', '하나대투증권'],
  ['DB', '굿모닝신한증권'],
  ['DC', '동부증권'],
  ['DD', '유진투자증권'],
  ['DE', '메리츠증권'],
  ['DF', '신영증권'],
  ['DG', '대우증권'],
  ['DH', '삼성증권'],
  ['DI', '교보증권'],
  ['DJ', '키움증권'],
  ['DK', '이트레이드'],
  ['DL', '솔로몬증권'],
  ['DM', '한화증권'],
  ['DN', 'NH증권'],
  ['DO', '부국증권'],
  ['DP', 'LIG증권'],
  ['BW', '뱅크월렛'],
  ['DQ', '디올투자증권'],
  ['DR', '토스증권'],
]

/** 옵션 `text`는 화면에만 쓰이고, API에는 `value`(은행 코드)만 전달 */
export const INICIS_REFUND_BANK_OPTIONS: InicisRefundBankOption[] = [
  { value: '', text: '은행을 선택하세요' },
  ...rows.map(([code, name]) => ({
    value: code,
    text: name,
  })),
]
